module.exports = __webpack_public_path__ + "svg/messages-icon.svg?fe3df8cedc0451b8203ff05e8f794b84";